import type { FetchedCrypto, FrontendCryptoFormat } from "~/types/global.types";

export const formatCryptosFrontend = (cryptos?: FetchedCrypto) => {
  if (!cryptos || cryptos?.length === 0) return [];
  const formattedCoins: FrontendCryptoFormat[] = cryptos.map((coin) => ({
    name: coin.symbol,
    fullName: coin.name,
    value: coin.symbol,
    rate: coin.rate,
  }));

  return formattedCoins;
};
